<template>
  <button
    type="submit"
    class="btn-primary bg-blue-500 hover:bg-blue-700 border text-white font-semibold text-sm py-2 px-4 rounded-xl w-full mt-5 disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    :disabled="isDisabled"
  >
    {{ isLogin ? 'LOGIN' : 'ENVIAR CÓDIGO' }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonSubmit',
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
